export const ROUTES = {
  base: "/",
  login: "/login",
  passwordForgot: "/password/forgot",
  passwordResetEmailSent: "/password/email-sent",
  passwordReset: "/password/reset",
  passwordCreate: "/password/create",
  passwordResetSuccess: "/password/reset/success",
  passwordCreatedSuccess: "/password/created/success",
  verificationSuccess: "/verification/success",
  home: "/home",
  dashboard: "/dashboard",
  partners: "/partners",
  partnerDetail: "/partners/:partnerId",
  partnerInfo: "/partner/info",
  users: "/users",
  userDetail: "/users/:userId",
  teachers: "/teachers",
  teacherDetail: "/teachers/:collaboratorId",
  coursesAndMaterials: "/courses-and-materials",
  editBundle: "/bundles/:bundleId/edit",
  editCourse: "/courses/:courseId/edit",
  meditations: "/meditations",
  addMeditation: "/meditations/new",
  editMeditation: "/meditations/:meditationId/edit",
  selfPacedCourse: "/self-paced-course",
  codes: "/codes",
  myProfile: "/my-profile",
  // activityLog: "/system/activity-log", // Removed
  // Added explore route for managing blog/research sections
  explore: "/explore",
  // App home management (featured meditation + "For You" boxes)
  appHome: "/app-home",
  notFound: "/not-found",
  serverError: "/unavailable",
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
  batchDetail: "/partners/:partnerId/batches/:batchId",
} as const;

export const MODAL_ROUTES = {
  exampleModal: "/example-modal",
  editProfile: "/edit-profile",
  editUser: "/edit-user",
  addPartner: "/add-partner",
  editPartner: "/edit-partner",
  addBatch: "/add-batch",
  editBatch: "/edit-batch",
  manageUserBundleAccess: "/manage-user-bundle-access",
  manageUserCourseAccess: "/manage-user-course-access",
  grantBundleAccess: "/grant-bundle-access",
  courseSectionExamples: "/course-section-example",
  manageUserAccessLevel: "/manage-user-access-level",
  lockUser: "/lock-user",
  previewFile: "/preview-file",
  addCollaborator: "/add-collaborator",
  editCollaborator: "/edit-collaborator",
  removeCollaborator: "/remove-collaborator",
  addTeacher: "/add-teacher",
  addPracticeType: "/add-practice-type",
  // Added explore modal routes for managing blog/research sections
  addExploreSection: "/add-explore-section",
  addExploreSubSection: "/add-explore-subsection",
} as const;
